import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { Helmet } from "react-helmet";
import { AppName } from "../../config";

const APP_NAME = AppName?.appName;

// console.log("App name", APP_NAME);

const Home = () => {
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <Helmet>
        <title>{APP_NAME}</title>
        <meta http-equiv="refresh" content="1;URL='/login'" />
        <meta
          name="description"
          content={`${APP_NAME} - Connect and share your content!`}
        />
        {/* <link rel="apple-touch-icon" href="%PUBLIC_URL%/icon/main-logo.png" /> */}
      </Helmet>
      {/* Add a Link to the Login page */}
      <Link to="/login" className="btn theme-button">
        Go to Login Page
      </Link>
    </div>
  );
};

export default Home;
